import {
  Paper,
  Text,
  Container,
  Image,
  Center,
  Button,
  Title,
  Grid,
  Space
} from "@mantine/core";
import React from "react";
import logo from "../images/logo.png";
import './register.css';
import failed from "../images/failed.png";
import success from "../images/success.png";
import expired from "../images/cross-2x.png";
import { Link, useSearchParams  } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function PasswordSuccess(): JSX.Element {
  const [searchParams] = useSearchParams();
  const message = searchParams.get("message");
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <>
        <Container>
            <Grid>
                <Grid.Col span={{ base: 12, md: 2, lg: 2 }}></Grid.Col>
                <Grid.Col span={{ base: 12, md: 8, lg: 8 }}>
                    <div className="password-success">
                        {message == 'SUCCESS' && (
                            <Paper withBorder p={30}>
                                <Image maw={120} mx="auto" radius="md" src={logo} />
                                <Space  h="md" />
                                <Center>
                                    <Image maw={120} mx="auto" radius="md" src={success} />
                                </Center>
                                <Space  h="md" />
                                <Title ta="center" order={3}>{t('passwordSuccess.title')}</Title>
                                <Space  h="xs" />
                                <Text ta="center" size="xs">{t('passwordSuccess.description')}</Text>
                                <Space  h="xl" />
                                <Center>
                                <Link to="/login">
                                    <Button variant="filled" size="md">{t('passwordSuccess.loginButton')}</Button>
                                </Link>
                                </Center>
                            </Paper>
                        )}
                        {message == 'FAILED' && (
                            <Paper withBorder p={30}>
                                <Image maw={120} mx="auto" radius="md" src={logo} />
                                <Space  h="md" />
                                <Center>
                                    <Image maw={120} mx="auto" radius="md" src={failed} />
                                </Center>
                                <Space  h="md" />
                                <Title ta="center" order={3}>{t('passwordSuccess.failedTitle')}</Title>
                                <Space  h="xs" />
                                <Text ta="center" size="md">{t('passwordSuccess.failedDescription')}</Text>
                                <Space  h="xl" />
                                <Center>
                                <Link to="/resetPassword">
                                    <Button w="300" variant="filled" size="md">{t('passwordSuccess.tryAgain')}</Button>
                                </Link>
                                </Center>
                            </Paper>
                        )}

                        {message == 'EXPIRED' && (
                            <Paper withBorder p={30}>
                                <Image maw={120} mx="auto" radius="md" src={logo} />
                                <Space  h="md" />
                                <Center>
                                    <Image maw={60} mx="auto" radius="md" src={expired} />
                                </Center>
                                <Space  h="md" />
                                <Text ta="center" size="md">{t('passwordSuccess.expiredTitle')}</Text>
                                <Space  h="xs" />
                                <Text ta="center" size="md">{t('passwordSuccess.expiredDescription')}</Text>
                                <Space  h="xl" />
                                <Center>
                                <Link to="/resetPassword">
                                    <Button w="300" variant="filled" size="md">{t('passwordSuccess.tryAgain')}</Button>
                                </Link>
                                </Center>
                            </Paper>
                        )}
                    </div>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 2, lg: 2 }}></Grid.Col>
            </Grid>
        </Container>
      </>
    </React.Fragment>
  );
}

export { PasswordSuccess };
